import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as UnauthorizedIcon } from '../../assets/images/layout/ErrorUnauthorized-rafiki.svg';
import "../../scss/pages/subscription.css";

const TechnicalError = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="unauthWrap">
        <UnauthorizedIcon />
        <h5>Technical Error</h5>
        <p>
          We're sorry, something went wrong on our end. Please try again in a
          few moments. If the issue persists, contact support.
        </p>
      </div>
      <div className="subsWrapper">
        <div className="plnaBtn">
          <button onClick={() => navigate("/")}>Try Again</button>
        </div>
      </div>
    </>
  );
};

export default TechnicalError;
